import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const glow = keyframes`
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 124, 214, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 124, 214, 0.8);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(255, 124, 214, 0);
      box-shadow: 0 0 0 10px rgba(255, 124, 214, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(255, 124, 214, 0);
      box-shadow: 0 0 0 0 rgba(255, 124, 214, 0);
  }
`

export const PlayButton = styled.button`
  cursor: pointer;
  transition: background 250ms;
  animation: ${glow} 2s infinite;
`

export const PresaveLink = styled.a`
  cursor: pointer;
  transition: background 250ms;
  animation: ${glow} 2s infinite;
`